import FondationsServiceModel   from '@/models/FondationsServiceModel';
import LanguageModel            from '@/models/services/fondations/LanguageModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import UserMeModel              from './UserMeModel';

@model.urnResource('user_languages')
@doc.path('/user_languages/{?id}')
export default class UserLanguageModel extends FondationsServiceModel {

	public declare _tsFilters: {
		'user': id;
	};

	public get position(): number {
		return this.get('position', 0);
	}

	@doc.model(LanguageModel) declare language: LanguageModel;
	@doc.model(UserMeModel) declare user: UserMeModel;
}